import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { JobStageIssueBySerialResponse, JobStageIssueResponse } from '../models/job-stage-issue.models';

export interface ResolveJobIssueRequest {
    resolutionNotes: string;
}

@Injectable({
    providedIn: 'root'
})
export class JobStageIssueService {
    private readonly apiUrl = `${environment.apiUrl}/v1/job-stage-issues`;

    constructor(private http: HttpClient) { }

    getJobStageIssues(): Observable<JobStageIssueResponse[]> {
        return this.http.get<JobStageIssueResponse[]>(this.apiUrl);
    }

    getJobStageIssuesByJobId(jobId: number): Observable<JobStageIssueResponse[]> {
        return this.http.get<JobStageIssueResponse[]>(`${this.apiUrl}/job/${jobId}`);
    }

    getJobStageIssuesBySerials(serialNumbers: string[]): Observable<JobStageIssueBySerialResponse[]> {
        return this.http.post<JobStageIssueBySerialResponse[]>(`${this.apiUrl}/by-serials`, { serialNumbers });
    }
    resolveJobIssue(id: number, request: ResolveJobIssueRequest): Observable<any> {
        return this.http.put(`${this.apiUrl}/${id}/resolve`, request);
    }
} 